import { z } from 'zod';

export const MODELS = [
  'anthropic/claude-sonnet-4-6',
  'anthropic/claude-opus-4-7',
  'anthropic/claude-haiku-4-5',
  'openai/gpt-4o',
  'openai/gpt-5',
  'openrouter/qwen-2.5',
] as const;

export const heartbeatSchema = z.object({
  enabled: z.boolean().default(true),
  intervalMinutes: z.coerce.number().int().min(5).max(480).default(60),
});

export const configSchema = z.object({
  defaultModel: z.string().default('anthropic/claude-sonnet-4-6'),
  lightContext: z.boolean().default(false),
  reasoning: z.boolean().default(true),
  heartbeat: heartbeatSchema.default({ enabled: true, intervalMinutes: 60 }),
});
export type Config = z.infer<typeof configSchema>;

export const updateConfigSchema = z.object({
  defaultModel: z.string().min(1, 'Selecione um modelo'),
  lightContext: z.boolean(),
  reasoning: z.boolean(),
  heartbeat: heartbeatSchema,
});
export type UpdateConfigInput = z.infer<typeof updateConfigSchema>;

export const healthSchema = z.object({
  ok: z.boolean(),
  uptime_s: z.coerce.number(),
  requests: z.coerce.number(),
  errors: z.coerce.number(),
  latency_p50_ms: z.coerce.number(),
  latency_p95_ms: z.coerce.number(),
  latency_p99_ms: z.coerce.number(),
  mem_rss_mb: z.coerce.number(),
  mem_heap_mb: z.coerce.number(),
  node_version: z.string(),
  hub_version: z.string(),
  ts: z.string(),
});
export type Health = z.infer<typeof healthSchema>;

const checkSchema = z.object({
  ok: z.boolean(),
  latency_ms: z.coerce.number().optional(),
  error: z.string().optional(),
});

export const deepHealthSchema = z.object({
  ok: z.boolean(),
  checks: z.record(checkSchema),
  uptime_s: z.coerce.number(),
  mem_rss_mb: z.coerce.number(),
  hub_version: z.string(),
  total_ms: z.coerce.number(),
  ts: z.string(),
});
export type DeepHealth = z.infer<typeof deepHealthSchema>;

export const MAINTENANCE_ACTIONS = ['flush_cache', 'reset_embeddings', 'backup'] as const;
export const maintenanceActionSchema = z.enum(MAINTENANCE_ACTIONS);
export type MaintenanceAction = z.infer<typeof maintenanceActionSchema>;

export const MAINTENANCE_LABEL: Record<MaintenanceAction, { title: string; desc: string }> = {
  flush_cache: {
    title: 'Limpar cache Redis',
    desc: 'Remove todas as chaves cache:* — força rebuild dos caches semânticos.',
  },
  reset_embeddings: {
    title: 'Resetar embeddings com falha',
    desc: 'Marca itens da fila de embeddings como pendentes para reprocessamento.',
  },
  backup: {
    title: 'Backup PostgreSQL',
    desc: 'Dispara dump assíncrono do Postgres (executado em background).',
  },
};

export const maintenanceResponseSchema = z.object({
  ok: z.boolean(),
  deleted: z.coerce.number().optional(),
  reset: z.coerce.number().optional(),
});
export type MaintenanceResponse = z.infer<typeof maintenanceResponseSchema>;

export const okSchema = z.object({ ok: z.boolean() });
